// The money screen (/money). Words it shares with the dialogs and the other money views
// (record a payment, the debt states, …) are read from `collections.board` rather than
// copied, so no two places can drift on what a state is called.
//
// NO EXPLANATION LINES. Titles, figures and actions speak for themselves; a sentence that
// explains the screen to the owner is a sentence they read once and scroll past forever.
// The three colours each carry one meaning — red late, amber our turn, blue not yet due.
export default {
  moneyScreen: {
    title: 'כספים',
    owed: 'מגיע לנו',
    viewTodo: 'מה צריך לעשות',
    viewByClient: 'לפי לקוח',
    showSettled: (n) => `הצגת מה ששולם (${n})`,
    sections: {
      late: { title: 'באיחור', empty: 'אין חיובים באיחור' },
      todo: { title: 'לטיפול שלנו', empty: 'אין מה לרשום' },
      owed: { title: 'ממתין לתשלום', empty: 'אין חיובים פתוחים' },
    },
    item: {
      monthCharge: 'חיוב חודשי',
      jobCharge: 'חיוב',
      monthToBill: 'לרשום חשבונית לחודש',
      monthlyByContract: 'לפי החוזה',
      lateSince: 'היה לשלם עד',
      dueBy: 'לתשלום עד',
      partlyPaid: (paid, amount) => `נגבו ${paid} מתוך ${amount}`,


      notBilling: 'עדיין לא מחייבת בעצמה',
      more: 'עוד',
    },
    tree: {
      retainerMonths: 'חודשי הריטיינר',
      jobs: 'עבודות',
      oneOffs: 'פרויקטים ועבודות בלי ריטיינר',
      noCharges: 'עוד לא נרשם חיוב',
      allPaid: 'הכול שולם',
      clientLate: (n) => (n === 1 ? 'חיוב אחד באיחור' : `${n} באיחור`),
      clientTodo: (n) => (n === 1 ? 'משימה אחת' : `${n} לטיפול`),
      empty: 'אין כספים להציג',
    },
    legend: {
      paid: 'שולם',
      owed: 'ממתין לתשלום',
      late: 'באיחור',
      toBill: 'לחייב',
      skipped: 'לא מחויב',
      future: 'טרם הגיע',
    },
  },
};
